export default "__VITE_ASSET__Bg5S9R3R__"